import intl from 'react-intl-universal';
import { useState, useEffect, useMemo, useRef } from 'react';
import { BetaSchemaForm } from '@ant-design/pro-components';
import type {
    ProFormColumnsType,
    ProFormProps,
    // ProFormInstance,
} from '@ant-design/pro-components';
import { message } from 'antd';
import { aftersaleReasonList } from '@/api/aftersaleOrder';
import { OTHERVALUE } from '@/enum/afterSales';

import style from './index.less';

interface Props extends ProFormProps {
    size?: string;
    fieldName: string; // 主键id
    // terminal: number; //终端：2-C端  4-Css
    isCreat?: boolean;
    product_code: string;
    aftersale_type: number; //售后单类型：1-换货 2-仅退款 3-退货退款 4-维修 5-补券 6-补发配件 9-补发颗粒 11-商品邮寄 100-创建工单类型

    value?: {
        first_reasons: {
            reason_value: string;
            reason_code: string | number;
        }[];
        second_reasons: any[];
        problem_pos: number;
        reason_other?: string; // 备注的备注原因
    };
    onChange?: (values: any) => void;
    onClassifyChange?: (value?: number) => void;
    onSecondReasonChange?: () => void;
}
const aftersaleTypeMap = {
    1: intl.get('换货'),
    2: intl.get('仅退款'),
    3: intl.get('退货退款'),
    4: intl.get('维修'),
    5: intl.get('补券'),
    6: intl.get('补发'),
    8: intl.get('其他'),
    9: intl.get('补发'), // 积木补件
    11: intl.get('商品邮寄'), // 商品邮寄
};

const AftersaleReason: React.FC<Props> = (props) => {
    const {
        // terminal,
        fieldName,
        product_code,
        aftersale_type,
        value,
        labelCol,
        onChange,
        onClassifyChange,
        onSecondReasonChange,
        isCreat = false,
        size = 'middle',
    } = props;
    // const formRef = useRef<ProFormInstance>();
    const [aftersaleReasonListInfo, setAftersaleReasonListInfo] = useState<{
        problem_pos_list: {
            value: number;
            label: string;
        }[];
        reason_list: any[];
    }>();
    const [currentFirstReason, setCurrentFirstReason] = useState<{
        [key: string]: any;
    } | null>({});
    const [secondReasonsList, setSecondReasonsList] = useState<any[]>([]);
    const [aftersale_classify, setAftersale_classify] = useState<
        number | undefined
    >();
    const [othervalue, setOthervalue] = useState<string>('');

    const initFirstReason = useRef<boolean>(false);

    useEffect(() => {
        aftersaleReasonListFn();
    }, []);

    useEffect(() => {
        // if (formRef.current && isCreat) {
        //     formRef.current.setFieldsValue({
        //         first_reasons: undefined,
        //         second_reasons: [],
        //         problem_pos: undefined,
        //     });
        //     onChange?.({
        //         first_reasons: undefined,
        //         second_reasons: [],
        //         problem_pos: undefined,
        //     });
        // }
        if (isCreat) {
            handlerChange?.({
                first_reasons: undefined,
                second_reasons: [],
                problem_pos: undefined,
            });
        }
    }, [isCreat]);

    useEffect(() => {
        // if (value?.first_reasons?.length) {

        //     handleFirstReasonChange(value.first_reasons[0]);
        // }

        if (value?.first_reasons?.length && !isCreat) {
            const first_reason_value = value?.first_reasons[0]?.reason_code;
            if (
                first_reason_value !== undefined &&
                aftersaleReasonListInfo?.reason_list?.length
            ) {
                const first_reason = aftersaleReasonListInfo?.reason_list.find(
                    (item) => item.value === first_reason_value,
                );
                if (
                    first_reason &&
                    !Object.keys(currentFirstReason || {})?.length
                ) {
                    setCurrentFirstReason(first_reason);
                    aftersaleReasonListFn(first_reason);
                    handlerChange({
                        first_reasons: value.first_reasons?.map((item) => ({
                            ...item,
                            label: item.reason_value,
                            value: item.reason_code,
                        })),
                    });
                }
            }
        }
    }, [value, aftersaleReasonListInfo]);

    useEffect(() => {
        if (aftersale_classify) {
            onClassifyChange?.(aftersale_classify);
        }
    }, [aftersale_classify]);

    const handlerChange = (newValue: { [key: string]: any }) => {
        onChange?.({
            ...(value || {}),
            ...(newValue || {}),
        });
    };

    const aftersaleReasonListFn = (first_reason = {}) => {
        const params = {
            terminal: 4,
            product_code,
            aftersale_type,
            first_reason,
        };

        aftersaleReasonList(params)
            .then((res) => {
                console.log('aftersaleReasonList', res);
                if (Object.keys(first_reason).length > 0) {
                    // 二级原因
                    setSecondReasonsList(
                        res?.data?.reason_list[0]?.child_reason?.reason_list,
                    );
                } else {
                    // 一级原因
                    setAftersaleReasonListInfo(res?.data || []);
                    // 如果只有一个一级原因，默认选中该一级，自动加载二级

                    if (
                        res?.data?.reason_list?.length === 1 &&
                        !initFirstReason.current &&
                        !value?.first_reasons
                    ) {
                        handlerChange({
                            first_reason: res?.data?.reason_list,
                        });
                        initFirstReason.current = true;

                        handleFirstReasonChange(res?.data?.reason_list[0]);
                    }
                }
            })
            .catch((err) => {
                console.log('aftersaleReasonList', err);
                message.error(intl.get('获取售后原因失败{err}', { err: err }));
            });
    };

    const handleFirstReasonChange = (firstReason: any) => {
        setCurrentFirstReason(firstReason);
        handlerChange({
            first_reasons: [
                {
                    ...firstReason,
                    reason_value: firstReason?.label,
                    reason_code: firstReason?.value,
                    must_attachment: firstReason?.must_attachment,
                },
            ],

            // first_reasons: [
            //     {
            //          reason_value: firstReason?.label,
            //          reason_code: firstReason?.value,
            //     },
            // ],
            second_reasons: [],
        });
        setAftersale_classify(undefined);
        aftersaleReasonListFn(firstReason);
    };

    const handleSecondOtherReasonChange = (e: InputEvent) => {
        const othervalue = e.target.value;
        setOthervalue(othervalue);
        const second_reasons = value?.second_reasons?.map((item) => {
            if (item.reason_code === OTHERVALUE) {
                return {
                    ...item,
                    reason_value: othervalue,
                };
            }
            return item;
        });

        handlerChange({
            second_reasons,
            reason_other: othervalue,
        });
    };

    const handleSecondReasonChange = (secondReason: any) => {
        const secondReasonData: any[] = [];
        secondReasonsList.forEach((item) => {
            if (secondReason && secondReason.includes(item.value)) {
                if (item.value === OTHERVALUE) {
                    secondReasonData.push({
                        ...item,
                        reason_code: item.value,
                        reason_value:
                            othervalue ||
                            value?.reason_other ||
                            item.reason_value,
                        aftersale_classify: item.aftersale_classify,
                    });
                } else {
                    secondReasonData.push({
                        ...item,
                        reason_code: item.value,
                        reason_value: item.label,
                        aftersale_classify: item.aftersale_classify,
                    });
                }

                // 这里只取第一个二级瑕疵原因，并抛出，外面去判断是什么时候更新分类
                if (!aftersale_classify) {
                    setAftersale_classify(item.aftersale_classify);
                }
            }
        });

        if (!secondReason?.length) {
            setAftersale_classify(undefined);
        }
        handlerChange?.({
            second_reasons: secondReasonData,
        });
        onSecondReasonChange?.();
    };

    const handleProblemPosChange = (problemPos: any) => {
        handlerChange?.({
            problem_pos: problemPos,
        });
    };

    const columns: ProFormColumnsType<any, FormItemValueType>[] =
        useMemo(() => {
            const reasonTypeName =
                aftersaleTypeMap[aftersale_type] || intl.get('售后');
            const columns: ProFormColumnsType<any, FormItemValueType>[] = [
                // 一级原因-售后原因
                {
                    title: intl.get('{reasonTypeName}原因', {
                        reasonTypeName: reasonTypeName,
                    }),
                    // dataIndex: 'first_reasons',
                    dataIndex: [fieldName, 'first_reasons'],
                    valueType: 'select',
                    formItemProps: {
                        labelCol,
                        rules: [
                            {
                                required: true,
                                message: intl.get(
                                    '请选择{reasonTypeName}原因',
                                    {
                                        reasonTypeName: reasonTypeName,
                                    },
                                ),
                            },
                        ],
                    },
                    fieldProps: {
                        size,
                        options: aftersaleReasonListInfo?.reason_list,
                        labelInValue: true,
                        onChange: handleFirstReasonChange,
                    },
                },
            ];

            if (currentFirstReason && value?.first_reasons?.length) {
                const { is_show_pos = false } = currentFirstReason;
                const second_reasons =
                    value?.second_reasons?.map((item) => item.reason_code) ||
                    [];
                columns.push(
                    ...[
                        {
                            title: intl.get('瑕疵原因'),
                            // dataIndex: [id, 'second_reasons'],
                            dataIndex: [fieldName, 'second_reasons'],
                            // dataIndex: 'second_reasons',
                            valueType: 'checkbox',
                            formItemProps: {
                                labelCol,
                                rules: [
                                    {
                                        required: true,
                                        message: intl.get('瑕疵原因必选'),
                                    },
                                ],
                            },
                            fieldProps: {
                                size,
                                value: second_reasons,
                                className: style.second_reasons_checkbox,
                                options:
                                    secondReasonsList?.length > 0 &&
                                    secondReasonsList.map((item) => {
                                        return {
                                            label: `${item.label} ${
                                                item.reason_remark
                                                    ? '（' +
                                                      item.reason_remark +
                                                      '）'
                                                    : ''
                                            }`,

                                            value: item.value,
                                        };
                                    }),
                                onChange: handleSecondReasonChange,
                            },
                        },
                        {
                            valueType: 'dependency',
                            name: ['second_reasons'],
                            columns: () => {
                                if (
                                    second_reasons &&
                                    second_reasons.includes(OTHERVALUE)
                                ) {
                                    return [
                                        {
                                            // dataIndex: [id, 'reason_other'],
                                            dataIndex: [
                                                fieldName,
                                                'reason_other',
                                            ],

                                            // dataIndex: 'reason_other',
                                            valueType: 'text',
                                            title: intl.get('其他原因'),
                                            formItemProps: {
                                                labelCol,
                                                rules: [
                                                    {
                                                        required:
                                                            second_reasons &&
                                                            second_reasons.includes(
                                                                OTHERVALUE,
                                                            ),
                                                        message:
                                                            intl.get(
                                                                '请输入其他原因',
                                                            ),
                                                    },
                                                    {
                                                        max: 10,
                                                        message:
                                                            intl.get(
                                                                '最多输入10个字符',
                                                            ),
                                                    },
                                                ],
                                            },
                                            fieldProps: {
                                                size,
                                                placeholder:
                                                    intl.get('请输入其他原因'),
                                                maxLength: 10,
                                                onChange:
                                                    handleSecondOtherReasonChange,
                                            },
                                        },
                                    ];
                                }
                                return [];
                            },
                        },
                        {
                            dataIndex: 'second_reasons_category_ids',
                            formItemProps: {
                                hidden: true,
                            },
                        },
                        is_show_pos && {
                            title: intl.get('瑕疵部位'),
                            // dataIndex: [id, 'problem_pos'],
                            dataIndex: [fieldName, 'problem_pos'],
                            // dataIndex: 'problem_pos',
                            valueType: 'select',
                            formItemProps: {
                                labelCol,
                                rules: [
                                    {
                                        required: true,
                                        message: intl.get('瑕疵部位必选'),
                                    },
                                ],
                            },
                            fieldProps: {
                                size,
                                placeholder: intl.get('请选择瑕疵部位'),
                                options:
                                    aftersaleReasonListInfo?.problem_pos_list ||
                                    [],
                                onChange: handleProblemPosChange,
                            },
                        },
                    ].filter((item) => !!item),
                );
            }
            return columns;
        }, [
            aftersaleReasonListInfo,
            value,
            secondReasonsList,
            currentFirstReason,
        ]);

    return (
        <div>
            <BetaSchemaForm<any>
                // formRef={formRef}
                shouldUpdate={true}
                key={product_code}
                layout="horizontal"
                layoutType="Embed"
                labelCol={labelCol}
                columns={columns}
                size={size}
            ></BetaSchemaForm>
        </div>
    );
};

export default AftersaleReason;
